import type { GridShapesMenu, Shape } from '~/types/grid.types'

export enum SHAPE_IDS_3D {
  CUBE_36x36x4_SET = 'Cube36x36x4Set',
  CUBE_36x36x2_SET = 'Cube36x36x2Set',
  CUBE_12x12x4_SET = 'Cube12x12x4Set',
  CUBE_12x12x2_SET = 'Cube12x12x2Set',
  RECT_12x36x4_SET = 'Rect12x36x4Set',
  RECT_12x36x4_SET_90 = 'Rect12x36x4Set90',
  RECT_12x36x2_SET = 'Rect12x36x2Set',
  RECT_12x36x2_SET_90 = 'Rect12x36x2Set90',
  // 3D Engraved
  CUBE_36x36x4_LARGE_PARALLEL = 'Cube36x36x4LargeParallel',
  CUBE_36x36x4_LARGE_PARALLEL_90 = 'Cube36x36x4LargeParallel90',
  CUBE_36x36x2_LARGE_PARALLEL = 'Cube36x36x2LargeParallel',
  CUBE_36x36x2_LARGE_PARALLEL_90 = 'Cube36x36x2LargeParallel90',
  CUBE_36x36x4_TANGENT = 'Cube36x36x4Tangent',
  CUBE_36x36x4_TANGENT_90 = 'Cube36x36x4Tangent90',
  CUBE_36x36x4_TANGENT_180 = 'Cube36x36x4Tangent180',
  CUBE_36x36x4_TANGENT_270 = 'Cube36x36x4Tangent270',
  CUBE_36x36x2_TANGENT = 'Cube36x36x2Tangent',
  CUBE_36x36x2_TANGENT_90 = 'Cube36x36x2Tangent90',
  CUBE_36x36x2_TANGENT_180 = 'Cube36x36x2Tangent180',
  CUBE_36x36x2_TANGENT_270 = 'Cube36x36x2Tangent270',
  CUBE_36x36x4_ZEN = 'Cube36x36x4Zen',
  CUBE_36x36x4_ZEN_90 = 'Cube36x36x4Zen90',
  CUBE_36x36x4_ZEN_180 = 'Cube36x36x4Zen180',
  CUBE_36x36x4_ZEN_270 = 'Cube36x36x4Zen270',
  CUBE_36x36x2_ZEN = 'Cube36x36x2Zen',
  CUBE_36x36x2_ZEN_90 = 'Cube36x36x2Zen90',
  CUBE_36x36x2_ZEN_180 = 'Cube36x36x2Zen180',
  CUBE_36x36x2_ZEN_270 = 'Cube36x36x2Zen270',
  CUBE_36x36x4_RIVER = 'Cube36x36x4River',
  CUBE_36x36x4_RIVER_90 = 'Cube36x36x4River90',
  CUBE_36x36x2_RIVER = 'Cube36x36x2River',
  CUBE_36x36x2_RIVER_90 = 'Cube36x36x2River90',
  CUBE_36x36x4_OFFSET = 'Cube36x36x4Offset',
  CUBE_36x36x4_OFFSET_90 = 'Cube36x36x4Offset90',
  CUBE_36x36x4_OFFSET_180 = 'Cube36x36x4Offset180',
  CUBE_36x36x4_OFFSET_270 = 'Cube36x36x4Offset270',
  CUBE_36x36x2_OFFSET = 'Cube36x36x2Offset',
  CUBE_36x36x2_OFFSET_90 = 'Cube36x36x2Offset90',
  CUBE_36x36x2_OFFSET_180 = 'Cube36x36x2Offset180',
  CUBE_36x36x2_OFFSET_270 = 'Cube36x36x2Offset270',
  CUBE_36x36x4_TOPO = 'Cube36x36x4Topo',
  CUBE_36x36x4_TOPO_90 = 'Cube36x36x4Topo90',
  CUBE_36x36x4_TOPO_180 = 'Cube36x36x4Topo180',
  CUBE_36x36x4_TOPO_270 = 'Cube36x36x4Topo270',
  CUBE_36x36x2_TOPO = 'Cube36x36x2Topo',
  CUBE_36x36x2_TOPO_90 = 'Cube36x36x2Topo90',
  CUBE_36x36x2_TOPO_180 = 'Cube36x36x2Topo180',
  CUBE_36x36x2_TOPO_270 = 'Cube36x36x2Topo270',
  CUBE_36x36x4_CONVERGE = 'Cube36x36x4Converge',
  CUBE_36x36x4_CONVERGE_90 = 'Cube36x36x4Converge90',
  CUBE_36x36x4_CONVERGE_180 = 'Cube36x36x4Converge180',
  CUBE_36x36x4_CONVERGE_270 = 'Cube36x36x4Converge270',
  CUBE_36x36x2_CONVERGE = 'Cube36x36x2Converge',
  CUBE_36x36x2_CONVERGE_90 = 'Cube36x36x2Converge90',
  CUBE_36x36x2_CONVERGE_180 = 'Cube36x36x2Converge180',
  CUBE_36x36x2_CONVERGE_270 = 'Cube36x36x2Converge270',
  CUBE_36x36x4_SUBWAY = 'Cube36x36x4Subway',
  CUBE_36x36x4_SUBWAY_90 = 'Cube36x36x4Subway90',
  CUBE_36x36x4_SUBWAY_180 = 'Cube36x36x4Subway180',
  CUBE_36x36x4_SUBWAY_270 = 'Cube36x36x4Subway270',
  CUBE_36x36x2_SUBWAY = 'Cube36x36x2Subway',
  CUBE_36x36x2_SUBWAY_90 = 'Cube36x36x2Subway90',
  CUBE_36x36x2_SUBWAY_180 = 'Cube36x36x2Subway180',
  CUBE_36x36x2_SUBWAY_270 = 'Cube36x36x2Subway270',
}

export const BLANK_3D_BOX_PREFIXES = [
  'Cube36x36x4',
  'Cube36x36x2',
  'Cube12x12x4',
  'Cube12x12x2',
  'Rect12x36x4',
  'Rect12x36x2',
] as const

export const isBlank3DBox = (prefix: string | null | undefined): boolean =>
  !prefix || BLANK_3D_BOX_PREFIXES.includes(prefix as any)

// Using FOOT_IN_PIXELS = 120, so INCH_IN_PIXELS = 10
// 36in = 360px, 12in = 120px, 4in = 40px, 2in = 20px
export const SHAPES: Shape[] = [
  {
    type: 'rect',
    id: SHAPE_IDS_3D.CUBE_36x36x4_SET,
    icon: 'CubeLarge4',
    prefix: 'Cube36x36x4',
    label: '36"×36"×4" (Set of 2)',
    w: 360,
    h: 360,
    d: 40,
    quantity: 2,
  },
  {
    type: 'rect',
    id: SHAPE_IDS_3D.CUBE_36x36x2_SET,
    icon: 'CubeLarge2',
    prefix: 'Cube36x36x2',
    label: '36"×36"×2" (Set of 2)',
    w: 360,
    h: 360,
    d: 20,
    quantity: 2,
  },
  {
    type: 'rect',
    id: SHAPE_IDS_3D.CUBE_12x12x4_SET,
    icon: 'CubeSmall4',
    prefix: 'Cube12x12x4',
    label: '12"×12"×4" (Set of 8)',
    w: 120,
    h: 120,
    d: 40,
    quantity: 8,
  },
  {
    type: 'rect',
    id: SHAPE_IDS_3D.CUBE_12x12x2_SET,
    icon: 'CubeSmall2',
    prefix: 'Cube12x12x2',
    label: '12"×12"×2" (Set of 8)',
    w: 120,
    h: 120,
    d: 20,
    quantity: 8,
  },
  {
    type: 'rect',
    id: SHAPE_IDS_3D.RECT_12x36x4_SET,
    icon: 'Rect4',
    prefix: 'Rect12x36x4',
    label: '12"×36"×4" (Set of 4)',
    w: 120,
    h: 360,
    d: 40,
    rotation: 0,
    quantity: 4,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS_3D.RECT_12x36x4_SET_90,
        icon: 'Rect4',
        prefix: 'Rect12x36x4',
        label: '12"×36"×4" Horizontal (Set of 4)',
        w: 120,
        h: 360,
        d: 40,
        rotation: 90,
        quantity: 4,
      },
    ],
  },
  {
    type: 'rect',
    id: SHAPE_IDS_3D.RECT_12x36x2_SET,
    icon: 'Rect2',
    prefix: 'Rect12x36x2',
    label: '12"×36"×2" (Set of 4)',
    w: 120,
    h: 360,
    d: 20,
    rotation: 0,
    quantity: 4,
    children: [
      {
        type: 'rect',
        id: SHAPE_IDS_3D.RECT_12x36x2_SET_90,
        icon: 'Rect2',
        prefix: 'Rect12x36x2',
        label: '12"×36"×2" Horizontal (Set of 4)',
        w: 120,
        h: 360,
        d: 20,
        rotation: 90,
        quantity: 4,
      },
    ],
  },
]

// 3D Engraved shapes — 36"×36" boxes with engraved patterns, sold in sets of 2
const ENGRAVED_PATTERNS = [
  { id: 'LargeParallel', label: 'Large Parallel', icon: 'EngravedLargeParallel', rotations: [90] },
  { id: 'Tangent', label: 'Tangent', icon: 'EngravedTangent', rotations: [90, 180, 270] },
  { id: 'Zen', label: 'Zen', icon: 'EngravedZen', rotations: [90, 180, 270] },
  { id: 'River', label: 'River', icon: 'EngravedRiver', rotations: [90] },
  { id: 'Offset', label: 'Offset', icon: 'EngravedOffset', rotations: [90, 180, 270] },
  { id: 'Topo', label: 'Topo', icon: 'EngravedTopo', rotations: [90, 180, 270] },
  { id: 'Converge', label: 'Converge', icon: 'EngravedConverge', rotations: [90, 180, 270] },
  { id: 'Subway', label: 'Subway', icon: 'EngravedSubway', rotations: [90, 180, 270] },
] as const

export const ENGRAVED_3D_SHAPES: Shape[] = ENGRAVED_PATTERNS.flatMap(({ id, label, icon, rotations }) => [
  {
    type: 'rect' as const,
    id: `Cube36x36x4${id}`,
    icon,
    prefix: `Cube36x36x4${id}`,
    label: `${label} 4" (Set of 2)`,
    w: 360,
    h: 360,
    d: 40,
    rotation: 0,
    quantity: 2,
    children: rotations.map(rot => ({
      type: 'rect' as const,
      id: `Cube36x36x4${id}${rot}`,
      icon,
      prefix: `Cube36x36x4${id}`,
      label: `${label} ${rot} 4" (Set of 2)`,
      w: 360,
      h: 360,
      d: 40,
      rotation: rot,
      quantity: 2,
    })),
  },
  {
    type: 'rect' as const,
    id: `Cube36x36x2${id}`,
    icon,
    prefix: `Cube36x36x2${id}`,
    label: `${label} 2" (Set of 2)`,
    w: 360,
    h: 360,
    d: 20,
    rotation: 0,
    quantity: 2,
    children: rotations.map(rot => ({
      type: 'rect' as const,
      id: `Cube36x36x2${id}${rot}`,
      icon,
      prefix: `Cube36x36x2${id}`,
      label: `${label} ${rot} 2" (Set of 2)`,
      w: 360,
      h: 360,
      d: 20,
      rotation: rot,
      quantity: 2,
    })),
  },
])

export const MENU: GridShapesMenu = {
  list: [
    {
      title: '3D Block Shape:',
      collapse: true,
      items: [
        ...SHAPES.filter((s: Shape) => [
          'Cube36x36x4Set',
          'Cube36x36x2Set',
        ].includes(s.id)),
        { breakpoint: true },
        ...SHAPES.filter((s: Shape) => [
          'Cube12x12x4Set',
          'Cube12x12x2Set',
          'Rect12x36x4Set',
          'Rect12x36x2Set',
        ].includes(s.id)),
      ],
    },
  ],
  default: SHAPES.find((s: Shape) => 'Cube36x36x4Set' === s.id),
}
